/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type { RouteRecordSingleViewWithChildren } from 'vue-router'

import AppLayout from '@/layouts/AppLayout.vue'
// DietDetail
import { DietDetail } from '@/pages/diets/DietDetail'
import { DietDetailAssumptions } from '@/pages/diets/DietDetailAssumptions'
import { DietDetailComments } from '@/pages/diets/DietDetailComments'
import { DietDetailDay } from '@/pages/diets/DietDetailDay'
import { DietDetailSettings } from '@/pages/diets/DietDetailSettings'
import { DietDetailShoppingList } from '@/pages/diets/DietDetailShoppingList'
import { DietDetailWeek } from '@/pages/diets/DietDetailWeek'
import { DietListSystem } from '@/pages/diets/DietListSystem'
import { DietListUniversity } from '@/pages/diets/DietListUniversity'
// DietList
import { DietListUser } from '@/pages/diets/DietListUser'

export const dietsRouter: RouteRecordSingleViewWithChildren = {
  children: [
    {
      component: DietListUser,
      meta: {
        title: 'Twoje jadłospisy',
      },
      name: 'DietListUser',
      path: 'user',
    },
    {
      component: DietListSystem,
      meta: {
        title: 'Jadłospisy systemowe',
      },
      name: 'DietListSystem',
      path: 'system',
    },
    {
      component: DietListUniversity,
      meta: {
        title: 'Jadłospisy studentów',
      },
      name: 'DietListUniversity',
      path: 'university',
      props: {
        dietType: 'university',
      },
    },
    {
      children: [
        {
          component: DietDetailWeek,
          meta: {
            title: 'Grafik tygodniowy',
          },
          name: 'DietDetailWeek',
          path: 'week',
          props: true,
        },
        {
          component: DietDetailDay,
          meta: {
            title: 'Grafik dzienny',
          },
          name: 'DietDetailDay',
          path: 'day/:dayIndex([0-9]|[12][0-9]|30)',
          props: true,
        },
        {
          component: DietDetailShoppingList,
          meta: {
            title: 'Lista zakupów',
          },
          name: 'DietDetailShoppingList',
          path: 'shopping-list',
          props: true,
        },
        {
          component: DietDetailComments,
          meta: {
            title: 'Komentarze',
          },
          name: 'DietDetailComments',
          path: 'comments',
          props: true,
        },
        {
          beforeEnter(to, _, next) {
            if (to.params.dietType === 'system') {
              next({ name: 'PageNotFound' })
            }
            next()
          },
          component: DietDetailSettings,
          meta: {
            title: 'Opis i właściwości',
          },
          name: 'DietDetailSettings',
          path: 'settings',
          props: true,
        },
        {
          beforeEnter(to, _, next) {
            if (to.params.dietType === 'system') {
              next({ name: 'PageNotFound' })
            }
            next()
          },
          component: DietDetailAssumptions,
          meta: {
            title: 'Założenia diety',
          },
          name: 'DietDetailAssumptions',
          path: 'assumptions',
          props: true,
        },
      ],
      component: DietDetail,
      name: 'DietDetail',
      path: ':dietType(user|system|university|patient)/:dietId(\\d+)',
      props: true,
      redirect: { name: 'DietDetailWeek' },
    },
  ],
  component: AppLayout,
  meta: {
    auth: true,
  },
  name: 'Diet',
  path: '/diet',
  props: true,
  redirect: { name: 'DietListUser' },
}
